App.namespace.wrap('es6.shared.tags_storage', () => {
  const ExpiringDataManager = App.es6.shared.expiring_data_manager;

  const expiringDataOptions = {
    // @see src/RoomTags/Repository/RoomTagEntitiesRepository::TAGS_KEY there is cache there as well
    storageItemName: 'tags-list-v21',
    // @todo Do not hardcode route 'room-tags.ajax.published'
    // The query string only busts HTTP caches; bump it together with storageItemName when the payload changes.
    ajaxEndpoint: '/tags?v=21',
    expirationTime: 1 * 60 * 60 * 1000, // Tags are stored in Local Storage for 1 hour
    isValidResponse: (response) => Boolean(response) && Array.isArray(response.tags),
    emptyValue: { tags: [] },
  };

  /**
   * Get tags from Storage or download new ones
   *
   * @return Object with tags parameter, containing array with tags
   * { tags: Array }
   */
  const getTags = () => ExpiringDataManager(expiringDataOptions).get();

  return {
    getTags,
  };
});
